module.exports = __webpack_public_path__ + "img/pin-600.e1f90b6b.png";